import { createBrowserRouter } from 'react-router';
import { AppRoutesEnum } from '@features/routing/routesEnum';
import { ProtectedPage } from '@features/routing/ProtectedPage';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import AppLogic from '@layouts/app-logic/AppLogic';
import PageLayout from '@layouts/page-layout/PageLayout';
import MessageLayout from '@layouts/message-layout/MessageLayout';
import NotFoundApp from 'components/base-elements/not-found/NotFoundApp';
import Orders from '@pages/orders/orders-page/Orders';
import Customers from '@pages/orders/customers-page/Customers';
import Search from '@pages/orders/search-page/Search';
import Preview from '@pages/preview/Preview';
import Filter from '@pages/filter/Filter';
import ReducedOrders from '@pages/reporting-pages/reduced-orders/ReducedOrders';
import ReducedMaterials from '@pages/reporting-pages/reduced-materials/ReducedMaterials';
import RedatedOrders from '@pages/reporting-pages/redated-orders/RedatedOrders';
import ShipmentStops from '@pages/reporting-pages/shipment-stops/ShipmentStops';
import UndeliveredOrders from '@pages/reporting-pages/undelivered-orders/UndeliveredOrders';
import DeliveriesMain from '@pages/reporting-pages/deliveries-main/DeliveriesMain';
import DeliveriesTradesDc from '@pages/reporting-pages/deliveries-trades-dc/DeliveriesTradesDc';
import DeliveriesTradesDistrict from '@pages/reporting-pages/deliveries-trades-district/DeliveriesTradesDistrict';
import DeliveriesCustomer from '@pages/reporting-pages/deliveries-customer/DeliveriesCustomer';
import DeliveriesSku from '@pages/reporting-pages/deliveries-sku/DeliveriesSku';
import DeliveriesSkuDc from '@pages/reporting-pages/deliveries-sku-dc/DeliveriesSkuDc';
import DeliveriesSkuDistrict from '@pages/reporting-pages/deliveries-sku-district/DeliveriesSkuDistrict';
import ImportSalesman from '@pages/upload-pages/import-salesman/ImportSalesman';
import ImportTelesales from '@pages/upload-pages/import-telesales/ImportTelesales';
import ImportMerchant from '@pages/upload-pages/import-merchant/ImportMerchant';
import ImportRegionManager from '@pages/upload-pages/import-region-manager/ImportRegionManager';
import ImportLocationManager from '@pages/upload-pages/import-location-manager/ImportLocationManager';



export const router = createBrowserRouter([
	{
		path: AppRoutesEnum.basePath,
		element: <AppLogic />,
		children: [
			{
				element: <PageLayout />,
				children: [
					{
						index: true,
						element: <Preview />
					},
					{
						path: AppRoutesEnum.orders,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.orders_Read}>
								<Orders />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.customers,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.customers_Read}>
								<Customers />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.search,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.orders_Read}>
								<Search />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.filter,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.userData_Read}>
								<Filter />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingReducedOrders,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.reducedOrdersReport_Read}>
								<ReducedOrders />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingReducedMaterials,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.reducedMaterialsReport_Read}>
								<ReducedMaterials />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingRedatedOrders,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.redatedOrdersReport_Read}>
								<RedatedOrders />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingShipmentStops,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.mchdReport_Read}>
								<ShipmentStops />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingUndeliveredOrders,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.undeliveredOrdersReport_Read}>
								<UndeliveredOrders />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingDeliveriesSummary,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.countryDeliveriesSummaryReport_Read}>
								<DeliveriesMain />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingDeliveriesTradesDc,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.countryDeliveriesTradesDepoReport_Read}>
								<DeliveriesTradesDc />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingDeliveriesTradesDistrict,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.countryDeliveriesTradesDistrictReport_Read}>
								<DeliveriesTradesDistrict />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingDeliveriesCustomer,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.countryDeliveriesCustomerReport_Read}>
								<DeliveriesCustomer />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingDeliveriesSku,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.countryDeliveriesSkuReport_Read}>
								<DeliveriesSku />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingDeliveriesSkuDc,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.countryDeliveriesSkuReportDcDetail_Read}>
								<DeliveriesSkuDc />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.reportingDeliveriesSkuDistrict,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.countryDeliveriesSkuReportDistrictDetail_Read}>
								<DeliveriesSkuDistrict />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.importSalesman,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.import_Modify}>
								<ImportSalesman />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.importTelesales,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.import_Modify}>
								<ImportTelesales />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.importMerchant,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.import_Modify}>
								<ImportMerchant />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.importRegionManager,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.import_Modify}>
								<ImportRegionManager />
							</ProtectedPage>
					},
					{
						path: AppRoutesEnum.importLocationManager,
						element:
							<ProtectedPage requiredRoles={AppRolesEnum.import_Modify}>
								<ImportLocationManager />
							</ProtectedPage>
					},
				]
			},
			{
				element: <MessageLayout />,
				children: [
					{
						path: "*",
						element: <NotFoundApp />
					}
				]
			}
		]
	}
]);